import { create } from 'mobx-persist';
import AuditStore from './audit.store';
import CampaignsStore from './campaigns.store';
import ClientsStore from './clients.store';
import CustomersStore from './customers.store';

import NotificationsStore from './notifications.store';
import ProductsStore from './products.store';
import QrCodesStore from './qrCodes.store';
import ShopsStore from './shops.store';
import ThemeStore from './theme.store';
import TransactionStore from './transactions.store';

import UserStore from './user.store';
import UsersStore from './users.store';
import UtilsStore from './utils.store';

class RootStore {
  theme: ThemeStore;
  user: UserStore;
  users: UsersStore;

  clients: ClientsStore;
  customers: CustomersStore;
  products: ProductsStore;
  transactions: TransactionStore;
  utils: UtilsStore;
  qrCodes: QrCodesStore;
  shops: ShopsStore;
  campaigns: CampaignsStore;
  notifications: NotificationsStore;
  audit: AuditStore;

  constructor() {
    this.user = new UserStore();
    this.users = new UsersStore();

    this.theme = new ThemeStore();
    this.clients = new ClientsStore();
    this.customers = new CustomersStore();
    this.products = new ProductsStore();
    this.transactions = new TransactionStore();
    this.utils = new UtilsStore();
    this.qrCodes = new QrCodesStore();
    this.shops = new ShopsStore();
    this.campaigns = new CampaignsStore();
    this.notifications = new NotificationsStore();
    this.audit = new AuditStore();
  }
}

const hydrate = create({
  storage: localStorage,
});

const store = new RootStore();

hydrate('user', store.user);
hydrate('users', store.users);

hydrate('theme', store.theme);
hydrate('clients', store.clients);
hydrate('customers', store.customers);
hydrate('products', store.products);
hydrate('transactions', store.transactions);
hydrate('utils', store.utils);
hydrate('qrCodes', store.qrCodes);
hydrate('shops', store.shops);
hydrate('campaigns', store.campaigns);
hydrate('notifications', store.notifications);
hydrate('audit', store.audit);

export {
  ThemeStore,
  UserStore,
  UsersStore,
  ClientsStore,
  CustomersStore,
  ProductsStore,
  TransactionStore,
  UtilsStore,
};
export default store;
